const memberCenter = () => import('@/view/memberCenter/index')
const memberList =() => import("@/view/memberCenter/memberList");
const channelList =() => import("@/view/memberCenter/channelList");
const memberGroup =() => import("@/view/memberCenter/memberGroup");
const labelManagement =() => import("@/view/memberCenter/labelManagement");
const newImport =() => import("@/view/memberCenter/newImport");
const memberImport =() => import("@/view/memberCenter/memberImport");
const newMemberGroup =() => import("@/view/memberCenter/newMemberGroup");
const groupDetail =() => import("@/view/memberCenter/groupDetail");
const populationAnalysis =() => import("@/view/memberCenter/populationAnalysis");
const newLabel =() => import("@/view/memberCenter/newLabel");
const labelGroup =() => import("@/view/memberCenter/labelGroup");
const newChannel =() => import("@/view/memberCenter/newChannel");
const channelDetails =() => import("@/view/memberCenter/channelDetails");
const newTemplate =() => import("@/view/memberCenter/newTemplate");
const memberDetail =() => import("@/view/memberCenter/memberDetail");
let router = [
    {
      path: '/memberCenter',
      component: memberCenter,
      name: 'memberCenter',
      redirect:"/memberCenter/memberlist",
      meta: {
        menuTitle: "会员中台",
        menuKey: "memberCenter",
        menuIcon: "icon-toker",
      },
      children:[
        {
          path:'memberManagement',
          component:memberCenter,
          name:"memberManagement",
          redirect:"/memberCenter/memberlist",
          meta:{
            menuKey:"memberCenter",
            menuTitle: "会员管理",
            menuIcon: "icon-member-management",
          },
          children:[
            {
              path:"/memberCenter/memberlist",
              component:memberList,
              name:'memberList',
              meta:{
                menuKey:"memberCenter",
                menuTitle: "会员列表",
                menuIcon: "el-icon-chat-dot-round",
                // secondMenuKey: 'autoPullDetail'
              }
            },
            {
              path:"/memberCenter/memberDetail",
              component:memberDetail,
              name:'memberDetail',
              meta:{
                menuKey:"memberCenter",
                secondMenuKey: 'memberList'
              }
            },
            {
              path:"/memberCenter/membergroup",
              component:memberGroup,
              name:'memberGroup',
              meta:{
                menuKey:"memberCenter",
                menuTitle: "会员群组",
                menuIcon: "el-icon-chat-dot-round",
              }
            },
            {
              path:"/memberCenter/groupDetail",
              component:groupDetail,
              name:'groupDetail',
              meta:{
                menuKey:"memberCenter",
                secondMenuKey: 'memberGroup'
              }
            },
            {
              path:"/memberCenter/populationAnalysis",
              component:populationAnalysis,
              name:'populationAnalysis',
              meta:{
                menuKey:"memberCenter",
                secondMenuKey: 'memberGroup'
              }
            },
            
            {
              path:"/memberCenter/memberImport",
              component:memberImport,
              name:'memberImport',
              meta:{
                menuKey:"memberCenter",
                menuTitle: "会员导入",
                menuIcon: "el-icon-chat-dot-round",
              }
            },
            {
              path:"/memberCenter/newImport",
              component:newImport,
              name:'newImport',
              meta:{
                menuKey:"memberCenter",
                secondMenuKey: 'memberImport'
              }
            },
            {
              path:"/memberCenter/newMemberGroup",
              component:newMemberGroup,
              name:'newMemberGroup',
              meta:{
                menuKey:"memberCenter",
                secondMenuKey: 'memberGroup'
              }
            },
          ]
        },
        {
          path:'MemberPortrait',
          component:memberCenter,
          name:"MemberPortrait",
          meta:{
            menuKey:"memberCenter",
            menuTitle: "会员画像",
            menuIcon: "icon-member-portrait",
          },
          children:[
            {
              path:"/memberCenter/labelManagement",
              component:labelManagement,
              name:'labelManagement',
              meta:{
                menuKey:"memberCenter",
                menuTitle: "标签管理",
                menuIcon: "el-icon-chat-dot-round",
              }
            },
            {
              path:"/memberCenter/newLabel",
              component:newLabel,
              name:'newLabel',
              meta:{
                menuKey:"memberCenter",
                secondMenuKey: 'labelManagement'
              }
            },
            {
              path:"/memberCenter/labelGroup",
              component:labelGroup,
              name:'labelGroup',
              meta:{
                menuKey:"memberCenter",
                secondMenuKey: 'labelManagement'
              }
            },
            {
              path:"/memberCenter/newChannel",
              component:newChannel,
              name:'newChannel',
              meta:{
                menuKey:"memberCenter",
                secondMenuKey: 'channelList'
              }
            },
          ]
        },
        {
          path:'channelManagement',
          component:memberCenter,
          name:"channelManagement",
          meta:{
            menuKey:"memberCenter",
            menuTitle: "渠道管理",
            menuIcon: "icon-channel-management",
          },
          children:[
            
            {
              path:"/memberCenter/channelList",
              component:channelList,
              name:'channelList',
              meta:{
                menuKey:"memberCenter",
                menuTitle: "渠道列表",
                menuIcon: "el-icon-chat-dot-round",
                // secondMenuKey: 'autoPullDetail'
              }
            },
            {
              path:"/memberCenter/newChannel",
              component:newChannel,
              name:'newChannel',
              meta:{
                menuKey:"memberCenter",
                secondMenuKey: 'channelList'
              }
            },
            {
              path:"/memberCenter/newTemplate",
              component:newTemplate,
              name:'newTemplate',
              meta:{
                menuKey:"memberCenter",
                secondMenuKey: 'channelList'
              }
            },
            {
              path:"/memberCenter/channelDetails",
              component:channelDetails,
              name:'channelDetails',
              meta:{
                menuKey:"memberCenter",
                secondMenuKey: 'channelList'
              }
            },
          ]
        }
      ]
    }
  ]
  export default router